import PersonasArchivos from './PersonasArchivos';

export default PersonasArchivos;
